import type { Highlight } from "../types";
import { wooProduct } from "../wordpress";

/**
 * Sobrepõe título e link com o produto real do WooCommerce quando o slug
 * existe no catálogo, preservando o mockup escolhido para o banner; fora do
 * WordPress (ou sem produto correspondente) mantém o dado fixo abaixo.
 */
function withProduct(slug: string, highlight: Highlight): Highlight {
	const product = wooProduct(slug);
	if (!product) return highlight;

	return {
		...highlight,
		title: product.title,
		href: product.href,
	};
}

/**
 * Vitrine do topo: novetats e agenda editorial. As peças do concurs "Blau de
 * vidre" têm secção própria (`concurs.ts`).
 */
export const highlights: Highlight[] = [
	withProduct("50-tacus", {
		id: "50-tacus",
		kicker: "nou llibre",
		title: "50 Tacus",
		description: "Construït a partir de fragments. Llegit com un tot.",
		cta: "descobreix el llibre",
		href: "/producte/50-tacus/",
		image: "/assets/MOCKUPS_LIVROS/50tacus_COSANOVA.png",
		color: "#ea7e35",
	}),
	withProduct("cartografia-de-lestrany-mapa-i-finestres", {
		id: "cartografia",
		kicker: "cartografia de l’estrany",
		title: "Mapa I: Finestres",
		description: "Setze veus catalanes travessen l’insòlit.",
		cta: "descobreix el llibre",
		href: "/producte/cartografia-de-lestrany-mapa-i-finestres/",
		image: "/assets/MOCKUPS_LIVROS/FINESTRES_COSANOVA.png",
		color: "#f2c14e",
		inkOnColor: true,
	}),
	{
		id: "presentacio",
		kicker: "llançament",
		title: "Pur",
		description: "Nara Vidal. Premi APCA 2024 a la millor novel·la brasilera.",
		cta: "vull saber-ne més",
		href: "/producte/pur-nara-vidal/",
		image: "/assets/MOCKUPS_LIVROS/PUR_COSANOVA.png",
		color: "#000000",
	},
	{
		id: "escapada",
		kicker: "experiències",
		title: "Escapada Literària",
		description: "Descobreix la nostra proposta d’escapades literàries.",
		cta: "descobreix-la",
		href: "https://cosanova.cat/escapada-literaria/",
		image: "/assets/pics/Escapada_Literearia_Cadaques.png",
		color: "#2f6b6a",
	},
];
